export const YONETICI = 'yonetici';
export const BINA_SAKINI = 'bina_sakini';
export const BINA_CALISANI = 'bina_calisani';

// backend/accounts/models.py Kullanici.KULLANICI_TIPI_CHOICES ile birebir.
export const ROL_ETIKETLERI = {
  [YONETICI]: 'Yönetici',
  [BINA_SAKINI]: 'Bina Sakini',
  [BINA_CALISANI]: 'Bina Çalışanı'
};
